import React, { FC } from "react";
import { Button, EmailConfirmationLogo } from "../../../../components";

interface EmailConfirmationContentProps {
  data: string;
  redirectToCalendar: () => void;
}

export const EmailConfirmationContent: FC<EmailConfirmationContentProps> = ({data, redirectToCalendar}) => (
  <div className='confirmation-page'>
    <p className='email-confirmation-message'>Почта подтверждена!</p>
    <p className='sub-confirmation-text'>{data}</p>
    <EmailConfirmationLogo divClassName='confirmation-logo'/>
    <Button onClick={redirectToCalendar} title='Перейти в календарь' className='medium-long routing-button'/>
  </div>
);
